import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Alert,
  Button,
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Spinner,
  Table,
  Tooltip,
} from "react-bootstrap";
import { getSurveys } from "../../redux/climalaboral/Encuestas/actions";
import CustomNavbar from "../../components/CustomNavbar";
import SidebarDashboard from "../../components/SidebarDashboard";
import UserHeadDetail from "../../components/UserHeadDetail";
import UserHeadDetailMenu from "../../components/UserHeadDetailMenu";
import { getDisciplinaryCases } from "../../redux/Modulo_Sanciones/diciplinarycase/actions";
import CustomPagint from "../../components/CustomPagint";
import { getFuncFichaEmpleado } from "../../redux/func_ficha_empleados/actions";

const History = (props) => {
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [item, setItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  //Redux
  const dispatch = useDispatch();

  const userN = useSelector((store) => store.auth.username);
  const userRoles = useSelector((store) => store.auth.userRoles);

  const data = useSelector((store) => store.funcTabEmployeed.ficha_empleado);
  const loading = useSelector(
    (store) => store.funcTabEmployeed.loadingFicha_Empleado
  );

  const { loaderDiciplinaryCases, disciplinaryCases } = useSelector(
    (store) => store.disciplinaryCase
  );
  const pages = Math.ceil(
    (disciplinaryCases ? disciplinaryCases.count : 0) / limit
  );

  const _getDisciplinaryCases = (
    offs = offset,
    lim = limit,
    busc = "",
    filt = ""
  ) =>
    dispatch(
      getDisciplinaryCases({
        offset: offs,
        limit: lim,
        tipo_busqueda: busc,
        filter: filt,
      })
    );
  useEffect(() => {
    if (userRoles && userRoles.length > 0 && userN) {
      // if (userRoles.includes("jefe")) {
      //   _getDisciplinaryCases(offset, limit, "jefe", parseInt(1));
      // } else {
      //   _getDisciplinaryCases(offset, limit, "empleado__codigo", userN);
      // }
      _getDisciplinaryCases(offset, limit, "empleado__codigo", userN);
      dispatch(
        getFuncFichaEmpleado(
          props.match.params.id,
          parseInt(props.match.params.type)
        )
      );
    }
  }, [userRoles]);

  const onView = (_item) => {
    setItem(_item);
    setShowModal(true);
    // dispatch(getitem(parseInt(_item.id_caso)));
  };

  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);
  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container mt-3 mb-3">
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            <>
              <UserHeadDetail data={data} type={props.match.params.type} />
              <div className="my-4">
                <UserHeadDetailMenu
                  id={props.match.params.id}
                  type={props.match.params.type}
                />
                <div className="mt-4 mb-3">
                  <div className="d-flex aling-items-center justify-content-between px-2">
                    <h5 className="font-weight-bold text-uppercase m-0">
                      <i
                        className="flex-wrap material-icons"
                        style={{ fontSize: "2rem", marginTop: "-.5rem" }}
                      >
                        timeline
                      </i>
                      &nbsp;Historial
                    </h5>
                    <div>
                      <span className="text-muted mr-3">
                        <i className="material-icons">vpn_key</i> Código:{" "}
                        {data.codigo}
                      </span>
                      <span className="text-muted mr-3">
                        <i className="material-icons">timer</i> Antigüedad:{" "}
                        {parseInt(data.antiguedad_laboral) < 1
                          ? ` ${parseInt(data.antiguedad_laboral)} meses`
                          : ` ${parseInt(
                              parseInt(data.antiguedad_laboral) / 12
                            )} años`}
                        {Math.floor(
                          (parseInt(data.antiguedad_laboral) / 12 -
                            parseInt(parseInt(data.antiguedad_laboral) / 12)) *
                            12
                        ) > 0
                          ? ` ${Math.floor(
                              (parseInt(data.antiguedad_laboral) / 12 -
                                parseInt(
                                  parseInt(data.antiguedad_laboral) / 12
                                )) *
                                12
                            )} meses`
                          : null}
                      </span>
                      <span className="text-muted">
                        <i className="material-icons">moving</i>{" "}
                        {data.Relacion_Laboral_List
                          ? data.Relacion_Laboral_List[0].descripcion
                          : "No ingresado aún"}
                      </span>
                    </div>
                  </div>
                  <hr className="mb-3" />
                  {loaderDiciplinaryCases ? (
                    <div className="d-flex justify-content-center">
                      <Spinner
                        animation="border"
                        role="status"
                        className="d-flex justify-content-center"
                      />
                    </div>
                  ) : disciplinaryCases && disciplinaryCases.count > 0 ? (
                    <>
                      <Table striped>
                        <thead>
                          <tr>
                            <th>Nombre</th>
                            <th>Descripción</th>
                            <th>Fecha creación</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {disciplinaryCases.data.map((_item) => (
                            <tr>
                              <td>{_item.list_codigo_empleado[0].nombre}</td>
                              <td>{_item.descripcion}</td>
                              <td>{_item.fecha_creacion}</td>
                              <td>
                                <OverlayTrigger
                                  placement="auto"
                                  overlay={
                                    <Tooltip {...props}>Ver detalle</Tooltip>
                                  }
                                >
                                  <Button
                                    size="sm"
                                    variant="link"
                                    type="button"
                                    onClick={() => onView(_item)}
                                  >
                                    <i className="material-icons">visibility</i>
                                  </Button>
                                </OverlayTrigger>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                      <CustomPagint
                        limit={limit}
                        setLimit={setLimit}
                        offset={offset}
                        setOffset={setOffset}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        dataLenght={disciplinaryCases.count}
                        pages={pages}
                        pagFunc={_getDisciplinaryCases}
                      />
                    </>
                  ) : (
                    <Alert className="my-4" variant="info">
                      Aún no hay datos, coctar al administrador para mas
                      información.
                    </Alert>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Form>
          <Modal.Header closeButton>
            <Modal.Title className="text-muted">Detalle del Caso</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group as={Col} className="mb-3">
              <Form.Label column sm="12" md="12">
                Caso disciplinario
              </Form.Label>
              <Row>
                <Col
                // sm={loaderDiciplinaryCases ? "10" : "12"}
                >
                  <Form.Control
                    name="casoDis"
                    className="rounded-pill"
                    required
                    disabled
                    type="text"
                    value={
                      item && item.caso_disciplinario
                        ? item.caso_disciplinario
                        : null
                    }
                    placeholder="Caso disciplinario activo"
                  ></Form.Control>
                </Col>
                {/* {loaderDiciplinaryCases && (
                  <Col sm="2">
                    <Spinner animation="border" size="sm" />
                  </Col>
                )} */}
              </Row>
            </Form.Group>
            <Form.Group as={Col} className="mb-3">
              <Form.Label column sm="12" md="12">
                Tipo de acción disciplinaria
              </Form.Label>
              <Form.Control
                name="disciplinaryActionType"
                className="rounded-pill"
                required
                disabled
                type="text"
                value={
                  item && item.list_accion_disciplinaria
                    ? item.list_accion_disciplinaria[0].nombre
                    : null
                }
                placeholder="Tipo de acción disciplinaria"
              ></Form.Control>
            </Form.Group>
            <Form.Group as={Col} className="mb-3">
              <Form.Label column sm="12" md="12">
                Creado por
              </Form.Label>
              <Form.Control
                name="createdBy"
                className="rounded-pill"
                required
                disabled
                type="text"
                value={
                  item && item.list_creado_por
                    ? item.list_creado_por[0].first_name +
                      " " +
                      item.list_creado_por[0].last_name
                    : null
                }
                placeholder="Creado por"
              ></Form.Control>
            </Form.Group>
            <Form.Group as={Col} className="mb-3">
              <Form.Label column sm="12" md="12">
                Encargado
              </Form.Label>
              <Form.Control
                name="userInCharge"
                className="rounded-pill"
                required
                disabled
                type="text"
                value={
                  item && item.list_id_encargado
                    ? item.list_id_encargado[0].first_name +
                      " " +
                      item.list_id_encargado[0].last_name
                    : null
                }
                placeholder="Encargado"
              ></Form.Control>
            </Form.Group>
            <Form.Group as={Col} className="mb-3">
              <Form.Label column sm="12" md="12">
                Fecha de vencimiento
              </Form.Label>
              <Form.Control
                name="fechaVenc"
                className="rounded-pill"
                required
                disabled
                type="text"
                value={
                  item && item.fecha_vencimiento ? item.fecha_vencimiento : null
                }
                placeholder="Fecha de vencimiento"
              ></Form.Control>
            </Form.Group>
            <Form.Group as={Col} className="mb-3">
              <Form.Label column sm="12" md="12">
                Estatus
              </Form.Label>
              <Form.Control
                name="estatus"
                className="rounded-pill"
                required
                disabled
                type="text"
                value={
                  item && item.list_estatus ? item.list_estatus[0].nombre : null
                }
                placeholder="Estatus"
              ></Form.Control>
            </Form.Group>
            <Form.Group as={Col} className="mb-3">
              <Form.Label column sm="12" md="12">
                Numero de ticket
              </Form.Label>
              <Form.Control
                name="numTicket"
                className="rounded-pill"
                required
                disabled
                type="text"
                value={item ? item.numero_ticket : null}
                placeholder="Numero de ticket"
              ></Form.Control>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={() => setShowModal(false)}
            >
              Cerrar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default History;
